import { Header } from 'components/header';
import useDashboardContext from 'contexts/dashboard.context';
import React, { FC } from 'react';
import { Outlet } from 'react-router-dom';

const DashboardContent: FC = () => {
  const { loading, activeCokitchen } = useDashboardContext();

  return (
    <div className='min-h-screen flex flex-col'>
      <div>
        <Header />
      </div>
      <main className='grow flex flex-col'>
        <div className='grow container flex flex-col max-sm:px-4 md:px-8 mx-auto py-8 md:pt-10'>
          {loading || !activeCokitchen.id ? (
            <div className='flex justify-center h-[50vh] items-center'>
              <p className='text-lg'>Loading cokitchen data...</p>
            </div>
          ) : (
            <Outlet />
          )}
        </div>
      </main>
    </div>
  );
};
export default DashboardContent;
